module.exports = __webpack_public_path__ + "img/icon_vip.e63b0503.png";